// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  margin: 10px;
  padding-left: 20px;
  padding-right: 20px;
}

.icon {
  padding: 10px;
}

.panel {
  margin-top: 10px;
  margin-bottom: 10px;
}

#page-mystudents {
  padding: 100px 50px 100px 50px;
  height: 100%;
  overflow: auto;
}

#titlebar.short {
  height: 50px;
  padding: 0;
}

.classlistwrapper {
  margin-top: 20px;
}

.classlistwrapper .class {
  margin-top: 8px;
  padding: 18px 20px 10px;
  overflow: auto;
}

.classlistwrapper .class.new {
  padding: 15px;
}

.classlistwrapper .class .tools {
  float: right;
  font-size: 14px;
  font-size: 1.4rem;
}

button {
  width: auto;
}

.modal button {
  width: 100%;
}

.classlistwrapper .class .tools span {
  vertical-align: middle;
}

.classlistwrapper .class .tools span a {
  text-decoration: none;
  font-weight: normal;
}

h2 {
  font-size: 18px;
  font-size: 1.8rem;
}

h2 small {
  margin-left: 10px;
  font-weight: normal;
}

ul.classdetails {
  list-style-type: none;
  margin: 15px 0 20px;
  padding: 0;
  font-size: 14px;
  font-size: 1.4rem;
}

ul.classdetails li {
  margin-bottom: 5px;
  transition: all 0.2s ease-out;
}

ul.classdetails li.edit {
  margin: 0;
  display: inline-block;
  margin-right: 30px;
}

ul.classdetails li.edit input,
ul.classdetails li.edit select {
  display: block;
}

ul.classdetails li span {
  display: inline-block;
}

ul.classdetails li {
  color: #858585;
}

ul.classdetails li.edit strong {
  margin-left: 3px;
}

.form_error {
  color: red;
  font-size: 12px;
  margin-bottom: 20px;
  display: block;
}

.emphasize {
  color: red;
  font-weight: bold;
}

.disabledDiv {
  opacity: 0.4;
}

.no-click {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/Courses/courses.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,gBAAA;EACA,mBAAA;AAGF;;AADA;EACE,8BAAA;EACA,YAAA;EACA,cAAA;AAIF;;AADA;EACE,YAAA;EACA,UAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,eAAA;EACA,uBAAA;EACA,cAAA;AAIF;;AADA;EACE,aAAA;AAIF;;AADA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,sBAAA;AAIF;;AADA;EACE,qBAAA;EACA,mBAAA;AAIF;;AADA;EACE,eAAA;EACA,iBAAA;AAIF;;AADA;EACE,iBAAA;EACA,mBAAA;AAIF;;AADA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAIF;;AADA;EACE,kBAAA;EACA,6BAAA;AAIF;;AADA;EACE,SAAA;EACA,qBAAA;EACA,kBAAA;AAIF;;AADA;;EAEE,cAAA;AAIF;;AADA;EACE,qBAAA;AAIF;;AADA;EACE,cAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,UAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAIF;;AADA;EACE,UAAA;EACA,iBAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,oBAAA;AAKF","sourcesContent":[".button{\n  margin: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.icon{\n  padding: 10px;\n}\n.panel{\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n#page-mystudents {\n  padding: 100px 50px 100px 50px;\n  height: 100%;\n  overflow: auto;\n}\n\n#titlebar.short {\n  height: 50px;\n  padding: 0;\n}\n\n.classlistwrapper {\n  margin-top: 20px;\n}\n\n.classlistwrapper .class {\n  margin-top: 8px;\n  padding: 18px 20px 10px;\n  overflow: auto;\n}\n\n.classlistwrapper .class.new {\n  padding: 15px;\n}\n\n.classlistwrapper .class .tools {\n  float: right;\n  font-size: 14px;\n  font-size: 1.4rem;\n}\n\nbutton {\n  width: auto;\n}\n\n.modal button {\n  width: 100%;\n}\n\n.classlistwrapper .class .tools span {\n  vertical-align: middle;\n}\n\n.classlistwrapper .class .tools span a{\n  text-decoration: none;\n  font-weight: normal;\n}\n\nh2 {\n  font-size: 18px;\n  font-size: 1.8rem;\n}\n\nh2 small {\n  margin-left: 10px;\n  font-weight: normal;\n}\n\nul.classdetails {\n  list-style-type: none;\n  margin: 15px 0 20px;\n  padding: 0;\n  font-size: 14px;\n  font-size: 1.4rem;\n}\n\nul.classdetails li {\n  margin-bottom: 5px;\n  transition: all 0.2s ease-out;\n}\n\nul.classdetails li.edit {\n  margin: 0;\n  display: inline-block;\n  margin-right: 30px;\n}\n\nul.classdetails li.edit input,\nul.classdetails li.edit select {\n  display: block;\n}\n\nul.classdetails li span {\n  display:inline-block;\n}\n\nul.classdetails li {\n  color: #858585;\n}\n\nul.classdetails li.edit strong {\n  margin-left: 3px;\n}\n\n.form_error {\n  color: red;\n  font-size: 12px;\n  margin-bottom: 20px;\n  display: block;\n}\n\n.emphasize {\n  color: red;\n  font-weight: bold;\n}\n.disabledDiv {\n  opacity: 0.4;\n}\n\n.no-click{\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
